// extracted by mini-css-extract-plugin
export default {"container":"BarItem_container__a8IxJ","number":"BarItem_number__cEuQE","notLast":"BarItem_notLast__r6nbn","text":"BarItem_text__MDIvw","image":"BarItem_image__zG5ln"};